<template>
    <div class="borrowDetailsBox">
        <Box title="设备调配归还审批">
            <div class="equipment box">
                <p class="title">设备信息</p>
                <div class="equipment-details">
                    <img src="@/assets/img/Icon_1.png" />
                    <div>
                        <div>
                            <p>资产名称：</p>
                            <p>资产编号：</p>
                            <p>规格型号：</p>
                            <p class="ellipsis">资产序列号：</p>
                        </div>
                        <div>
                            <p class="ellipsis">{{equipment.SBBH}}</p>
                            <p class="ellipsis">{{equipment.SBMC}}</p>
                            <p class="ellipsis">{{equipment.SBXH}}</p>
                            <p class="ellipsis">{{equipment.SBXLH}}</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="ellipsis">管理科室： {{equipment.GLKS}}</div>
                    <div class="ellipsis">注册证件号：{{equipment.ZCZJH}}</div>
                </div>
            </div>

            <div class="accessories box">
                <p class="title">配件信息</p>
                <div style="color: #666666;" v-if="accessories.length===0">暂无</div>
                <div>
                    <div>
                        <!--class="check-box"-->
                        <van-checkbox-group v-model="resultEd" disabled>
                            <div class="check-box" v-for="(item, index) in accessories">
                                <van-checkbox :name="index" checked-color="#4fa69e">{{item.PJMC}}</van-checkbox>
                                <span>{{item.BZ}}</span>
                            </div>
                        </van-checkbox-group>
                    </div>
                </div>
            </div>
            <div class="borrow box">
                <p class="title">调配信息</p>
                <Field title="申请单号" :text="equipment.DH" type="text" :readonly="true" />
                <Field title="申请人" :text="equipment.SQRMC" type="text" :readonly="true" />
                <Field title="联系方式" :text="equipment.LXFS" type="text" :readonly="true" />
                <Field title="申请科室" :text="equipment.SQKSMC" type="text" :readonly="true" />
                <Field title="借用申请日期" :text="$format(equipment.SQRQ,'YYYY-MM-DD')" type="text" :readonly="true" />
                <Field title="实际借用日期" :text="$format(borrow.PracticalBorrowDate,'YYYY-MM-DD HH:mm:ss')" type="text" :readonly="true" />
                <Field title='借用单价' :action='true' type='text' :text='`${borrow.JFBZ}元`' />
                <Field title='当前借用时长' :action='true' type='text' :text='`${borrow.Duration}小时`' />
                <Field title='当前借用金额' :action='true' type='text' :text='`${Number(borrow.JFBZ*borrow.Duration).toFixed(2)}元`' />
                <Field title='实际(优惠)金额' :action='true' type='text' :text='`${borrow.Unit}元`' />
                <Field title="申请说明" :Isdisabled="true" :text="equipment.GHSQYY" type="textarea" />
                <van-cell>
                    <template>
                        <div class="borrowHelper" @click="show=true">
                             <span>帮助</span>
                             <img src="@/assets/img/Helper.png" />
                        </div>
                    </template>
                </van-cell>
            </div>

            <van-popup v-model="show" position="bottom" round :style="{width:'100%'}">
                <div>
                    <div>
                        <div class="FYBZTitle">
                            <span>当前计费形式:</span><span>{{FYBZMC}}</span>
                            <p>借用金额最终以归还申请的审核时间为截点来计算</p>
                        </div>
                        <van-cell title="正常计费" />
                        <van-cell>
                            <template>
                                <div class="JFBZ">
                                    借用金额=计费单价*计费时长
                                </div>
                            </template>
                        </van-cell>
                        <van-cell title="24小时计费" />
                        <van-cell>
                            <template>
                                <div class="JFBZ">
                                    借用金额=24小时计费单价*计费时长/24
                                </div>
                                <div class="JFBZ">
                                    例:(计费单价3元/小时;65元/天;计费时长240小时;<br/>借用金额=65*240/24)
                                </div>
                            </template>
                        </van-cell>
                        <van-cell title="递进计费"/>
                        <van-cell>
                            <template>
                                <div class="JFBZ">
                                    借用金额=第一阶梯内时长*计费单价*阶梯内折扣+第二阶梯内时长*计费单价*阶梯内折扣+(n...)
                                </div>
                                <div class="JFBZ">
                                    未达到递进标准:借用金额=计费单价*计费时长
                                </div>
                            </template>
                        </van-cell>
                    </div>
                </div>
            </van-popup>

            <div class="box">
                <p class="title">审批信息</p>
                <van-radio-group v-model="radio" direction="horizontal">
                    <p style="width: 50%;">审批结果</p>
                    <van-radio :name="1" icon-disabled checked-color="#07c160">通过</van-radio>
                    <van-radio :name="''" icon-disabled checked-color="#07c160">否决</van-radio>
                </van-radio-group>
                <Field title="审批说明" type="textarea" :action="true"  placeholder ="请填写审批说明" @onMessage='e=>GHSPYY=e'/>
            </div>
        </Box>
        <div class="footer">
            <div class="button" @click="upload">提交审批</div>
        </div>
    </div>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import {
        Popup,
        Cell,
        Toast,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        ImagePreview
    } from 'vant'
    import Field from '@/components/field/field'
    export default {
        name: 'DeployGiveDefault',
        data() {
            return {
                show:false,
                borrow:{},//借用信息
                //    设备信息
                equipment: {},
                //    配件信息
                accessories: [],
                //    选中的配件信息
                resultEd:[],//借用的选中状态
                //    申请说明
                GHSPYY:'',
                radio:1,
                FYBZMC:null,
            }
        },
        components: {
            Box,
            Field,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup,
            [Radio.name]: Radio,
            [RadioGroup.name]: RadioGroup,
            [Cell.name]:Cell,
            [Popup.name]:Popup,
        },
        mounted() {
            this.equipment = this.$route.query.Equipment;
            this.loadDeployPJ();
        },
        methods: {
            loadDeployPJ() {
                const _this=this;
                 _this.$axios.all([_this.$get('api/DeployEquipment/GetDeployAuditPJInfo',{
                    DH: _this.equipment.DH,
                    JYLB: 'N'
                }),_this.$get('api/DeployEquipment/GetBorwerCost',{
                    SQDH:_this.equipment.DH,
                })]).then(_this.$axios.spread(function(result1,result2){
                    try{
                        _this.accessories=result1;
                        for(let i=0;i<_this.accessories.length;i++){
                            let data=_this.accessories[i];
                            if(data.SYZT==='Y'){
                                _this.resultEd.push(i);
                            }
                        }
                       _this.borrow=JSON.parse(result2)
                       _this.FYBZMC=_this.borrow.FYBZ==='Y'?'正常计费':_this.borrow.FYBZ==='N'?'24小时计费':'递进计费';
                    }catch(e){
                       _this.$Toast('数据异常,请联系管理员!');
                    }
                }));
            },
            upload() { //提交归还申请
                this.$get('api/DeployEquipment/DeployGiveBackAudit',{
                        SQDH:String.trim(this.equipment.DH),
                        SHR:this.$UserInfo.UserId,
                        GHSHBZ:this.radio,
                        SPBZYY:this.GHSPYY
                }).then(result=>{
                   if(result.code===10000){
                       Toast(result.msg);
                       setTimeout(X => {
                           this.$router.go(-1);
                       }, 500);
                   }else{
                       Toast(result.msg);
                   }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    .borrowDetailsBox {
        padding-bottom: 120px;
    }

    .box {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 34px 40px 0;
        box-sizing: border-box;
        margin-bottom: 20px;
    }

    .title {
        color: $TEXT-DARK-COLOR;
        font-size: 34px;
        font-weight: bold;
    }

    .equipment {
        height: 424px;
        img {
            width: 150px;
            height: 150px;
        }

        .equipment-details {
            display: flex;
            margin-top: 24px;

            &>div {
                margin-left: 34px;
                display: flex;
                div {
                    &:first-child {
                        color: #999;
                        line-height: 55px;
                    }

                    &:last-child {
                        color: #333;
                        line-height: 55px;

                        p {
                            width: 280px;
                            font-size: 29px;
                            color: #333;
                        }
                    }
                }
            }
        }

        &>div:last-child {
            display: flex;
            border-top: 2px solid #F3F3F3;
            margin-top: 20px;

            div {
                flex: 1;
                text-align: left;
                height: 66px;
                line-height: 66px;
                font-size: 29px;
                color: #999;

                &:first-child {
                    border-right: 2px solid #F3F3F3;
                }
            }
        }
    }

    .accessories {
        .title {
            margin-bottom: 10px;
        }
        .check-box {
            display: flex;
            height: 112px;
            border-bottom: 2px solid #F3F3F3;

            .van-checkbox {
                flex: 1;
            }
            span{
                margin-top: 30px;
            }
        }
        .check-box1{
            .van-checkbox{
                width: 60px;
            }
        }
    }
    .explain {
        input {
            width: 100%;
            text-align: left;
            margin: 20px 0 48px;
        }
        span{
            color:#ff2947;
        }
    }

    input {
        width: 150px;
        font-size: 29px;
        text-align: center;
        color: #858585;

        &::-webkit-input-placeholder {
            color: #858585;
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 114px;
        background: $BACKGROUND-COLOR;
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
        padding-top: 24px;

        .button {
            width: 690px;
            height: 96px;
            background: $THEME-COLOR;
            border-radius: 8px;
            color: $TEXT-LIGHT-COLOR;
            font-size: 30px;
            text-align: center;
            line-height: 96px;
            margin: auto;
        }
    }

    .borrowHelper{
        float: right;
        color: #666666;
        height: 50px;
        span{
           position: absolute;
           top: 0px;
           right: 38px;
           bottom: 0px;
        }
        img{
            width: 40px;
            height:40px;
        }
    }

    .JFBZ{
        color: #969799;
        text-align: left;
    }
    .FYBZTitle{
        background: #4FA69E;
        height: 70px;
        text-align: left;
        span{
            color: #FFFFFF;
            margin-left: 25px;
        }
        p{
            font-size: 12px;
            color:#FFFFFF;
            text-indent: 2em;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/DeployGiveAuditDefault/DeployGiveAuditDefault.vue